enum Phase {
    PhaseI = 1,
    PhaseII = 2,
    PhaseIII = 3,
    PhaseIV = 4,
    PhaseV = 5,
}

export default Phase;
